import { DATE_FORMAT, FilterOperator, MetricView } from '@nemuru-eng/js-api-client';

import { CustomDate } from '../CustomDate';
import { QueryBuilder } from '../QueryBuilder';
import { TimeInterval } from '../TimeInterval';
import { MetricFilter } from './MetricFilter';

export class StartDateFilter extends MetricFilter<TimeInterval> {
  public field = 'start_date';
  public operator = FilterOperator.GTE;

  constructor(timeInterval: TimeInterval[]) {
    super(timeInterval);
  }

  public value(): string {
    return new CustomDate(this.values[0].previous.start).formatDate(DATE_FORMAT.YYYY_MM_DD);
  }

  protected areValuesIncluded(newMetricFilter?: StartDateFilter): boolean {
    if (!this.values) return true;
    if (!newMetricFilter) return false;
    return this.values[0].previous.start <= newMetricFilter.values[0].previous.start;
  }

  public needsRequest(newQueryBuilder: QueryBuilder): boolean {
    const newFilter = newQueryBuilder.metricFilter<StartDateFilter>(this);
    if (this.areValuesIncluded(newFilter)) return false;
    return true;
  }

  public merge(newMetricFilter: StartDateFilter): this {
    if (!(newMetricFilter instanceof StartDateFilter)) return this;
    if (this.areValuesIncluded(newMetricFilter)) return this;
    return new StartDateFilter([...newMetricFilter.values]) as this;
  }

  public filterMetrics<K extends MetricView>(metrics: K[]): K[] {
    const startDate = this.values[0].previous.start;
    return metrics.map((metricView) => ({
      ...metricView,
      metrics: metricView.metrics.map((metric) => ({
        ...metric,
        metricsByDate: metric.metricsByDate.filter((metricByDate) => metricByDate.date >= startDate),
      })),
    }));
  }
}
